export default __webpack_public_path__ + "static/media/hero.cd27616c.webp";